import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LanguageSwitcher } from "./i18n/LanguageSwitcher";

export default function Header() {
  return (
    <div
      className="bg-light display-4 py-2 d-flex align-items-center"
      style={{ paddingLeft: 16, paddingRight: 16 }}
    >
      <span className="flex-grow-1">
        <FontAwesomeIcon icon={faLayerGroup} /> Songship
      </span>
      <LanguageSwitcher />
    </div>
  );
}
